import { render, staticRenderFns } from "./MultiFreqCorridor.vue?vue&type=template&id=c9cd9c78&"
import script from "./MultiFreqCorridor.vue?vue&type=script&lang=ts&"
export * from "./MultiFreqCorridor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports